export default "__VITE_ASSET__Lm5RU2gZ__"